import { VendorPricingAgreement } from '@types'

export const SET_EDIT_VENDOR_PRICING_AGREEMENT =
  'SET_EDIT_VENDOR_PRICING_AGREEMENT'
export const setEditVendorPricingAgreement = (
  vendorPricingAgreement: VendorPricingAgreement | null,
) => ({
  type: SET_EDIT_VENDOR_PRICING_AGREEMENT,
  payload: vendorPricingAgreement,
})

export const CLEAR_EDIT_VENDOR_PRICING_AGREEMENT =
  'CLEAR_EDIT_VENDOR_PRICING_AGREEMENT'
export const clearEditVendorPricingAgreement = () => ({
  type: CLEAR_EDIT_VENDOR_PRICING_AGREEMENT,
})

export const SET_UNIVERSAL_VENDOR_PRICING_AGREEMENTS =
  'SET_UNIVERSAL_VENDOR_PRICING_AGREEMENTS'
export const setUniversalVendorPricingAgreements = (
  vendorPricingAgreements: VendorPricingAgreement[] | null,
) => ({
  type: SET_UNIVERSAL_VENDOR_PRICING_AGREEMENTS,
  payload: vendorPricingAgreements,
})

export const SET_UNIVERSAL_VENDOR_PRICING_AGREEMENT_IN_AGREEMENTS =
  'SET_UNIVERSAL_VENDOR_PRICING_AGREEMENT_IN_AGREEMENTS'
export const setUniversalVendorPricingAgreementInAgreements = (
  vendorPricingAgreement: VendorPricingAgreement | null,
) => ({
  type: SET_UNIVERSAL_VENDOR_PRICING_AGREEMENT_IN_AGREEMENTS,
  payload: vendorPricingAgreement,
})

export const SET_MARKET_VENDOR_PRICING_AGREEMENTS =
  'SET_MARKET_VENDOR_PRICING_AGREEMENTS'
export const setMarketVendorPricingAgreements = (
  vendorPricingAgreements: VendorPricingAgreement[] | null,
) => ({
  type: SET_MARKET_VENDOR_PRICING_AGREEMENTS,
  payload: vendorPricingAgreements,
})

export const SET_MARKET_VENDOR_PRICING_AGREEMENT_IN_AGREEMENTS =
  'SET_MARKET_VENDOR_PRICING_AGREEMENT_IN_AGREEMENTS'
export const setMarketVendorPricingAgreementInAgreements = (
  vendorPricingAgreement: VendorPricingAgreement | null,
) => ({
  type: SET_MARKET_VENDOR_PRICING_AGREEMENT_IN_AGREEMENTS,
  payload: vendorPricingAgreement,
})

export const SET_VENDOR_MARKET_VENDOR_PRICING_AGREEMENTS =
  'SET_VENDOR_MARKET_VENDOR_PRICING_AGREEMENTS'
export const setVendorMarketVendorPricingAgreements = (
  vendorPricingAgreements: VendorPricingAgreement[] | null,
) => ({
  type: SET_VENDOR_MARKET_VENDOR_PRICING_AGREEMENTS,
  payload: vendorPricingAgreements,
})

export const SET_VENDOR_MARKET_VENDOR_PRICING_AGREEMENT_IN_AGREEMENTS =
  'SET_VENDOR_MARKET_VENDOR_PRICING_AGREEMENT_IN_AGREEMENTS'
export const setVendorMarketVendorPricingAgreementInAgreements = (
  vendorPricingAgreement: VendorPricingAgreement | null,
) => ({
  type: SET_VENDOR_MARKET_VENDOR_PRICING_AGREEMENT_IN_AGREEMENTS,
  payload: vendorPricingAgreement,
})
